import { registerLocale } from 'react-datepicker';
import {enCA, enGB, enUS, es, frCA, ptBR, zhCN} from 'date-fns/locale'

export const registerDatePickerLocale = language => {
  switch(language) {
    case 'en-AU': // en-AU not currently available in date-fns
    case 'en-CA':
      registerLocale(language, enCA);
      break;
    case 'en-GB':
      registerLocale(language, enGB);
      break;
    case 'en-US':
      registerLocale(language, enUS);
      break;
    case 'es-MX': // es-MX not currently available in date-fns
      registerLocale(language, es);
      break;
    case 'fr-CA': // fr-CA not currently available in date-fns
      registerLocale(language, frCA);
      break;
    case 'pt-BR':
      registerLocale(language, ptBR);
    case 'zh-CH':
      registerLocale(language, zhCN);
      break;
    default:
      registerLocale(language, enUS);
  }
};